import { DescriptionText } from "../../styled";
import intl from "react-intl-universal";
import {Content} from './styled'

interface SimpleLineProps {
  reason?: string;
}

const SimpleLine = (props: SimpleLineProps) => {
  const { reason } = props;

  return (
    <Content>
      <DescriptionText>
        {reason ?? intl.get("stocks.suggestionContext.simpleLine.defaultReason")}
      </DescriptionText>
    </Content>
  );
};

export default SimpleLine;
